import API_GDS_tariff from "./GDS_tariff";
import API_rebuild_flight from "./rebuild_flight";
import API_tour_search_for_map from "./tour_search_for_map";

export const GDSTariff = API_GDS_tariff;
export const RebuildFlight = API_rebuild_flight;
export const TourSearchForMap = API_tour_search_for_map;

